
import StatCardSection from './Card';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function Card5({seleccionesHechas}) {
  if (seleccionesHechas === null || seleccionesHechas === undefined || seleccionesHechas === 'empty') {
    
        return (
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="card shadow h-100 py-2">
              <div className="card-body">
                <Skeleton height={20} width={120} className="mb-2" />
                <Skeleton height={30} width={80} />
              </div>
            </div>
          </div>
        );
      }


  return (

    <StatCardSection
      title="SELECCIONES REALIZADAS"
      value={seleccionesHechas}
      color="info"
      icon="fa-users"

    />
  );
}
